let lenisInstance = null;

export const setLenis = (instance) => {
    lenisInstance = instance;
};

export const getLenis = () => lenisInstance;

export function scrollToSection(hash) {
    if (hash === "#top") {
        if (lenisInstance) {
            lenisInstance.scrollTo(0, { duration: 1.5 });
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
        return;
    }
    const el = document.querySelector(hash);
    if (!el) return;
    if (lenisInstance) {
        lenisInstance.scrollTo(el, {
            offset: -72,
            duration: 1.5,
            easing: (t) => 1 - Math.pow(1 - t, 4),
        });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}
